var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerProfession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.5V5.5C6 3.84315 7.34315 2.5 9 2.5H11C12.6569 2.5 14 3.84315 14 5.5V6.5H16C17.1046 6.5 18 7.39543 18 8.5V12.0708C15.5096 12.9947 12.8149 13.4999 10 13.4999C7.18514 13.4999 4.49037 12.9947 2 12.0707V8.5C2 7.39543 2.89543 6.5 4 6.5H6ZM8 5.5C8 4.94772 8.44772 4.5 9 4.5H11C11.5523 4.5 12 4.94772 12 5.5V6.5H8V5.5ZM9 10.5C9 9.94772 9.44772 9.5 10 9.5H10.01C10.5623 9.5 11.01 9.94772 11.01 10.5C11.01 11.0523 10.5623 11.5 10.01 11.5H10C9.44772 11.5 9 11.0523 9 10.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.1923V16.5C2 17.6046 2.89543 18.5 4 18.5H16C17.1046 18.5 18 17.6046 18 16.5V14.1923C15.4872 15.0404 12.7964 15.4999 10 15.4999C7.20363 15.4999 4.51279 15.0404 2 14.1923Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerProfession);
export default __webpack_public_path__ + "static/media/computer-profession.8fe7f8962df500f8a4823da50168f2d2.svg";
export { ForwardRef as ReactComponent };